export function isTouchDevice() {
  return "ontouchstart" in window;
}